import React from 'react';
import BubbleCommon, {
  TipsMapType,
} from '@/pages/opinion/components/BubbleCommon';
import { LangType, TipsType } from '../types';
import SvgIcon from '@/pages/home/components/SvgIcon';

const andText: TipsMapType = {
  en: 'Filter the content in selected language from the selected region/ country',
  zh: '从已选的【region/country】中筛选出【已选语种】的内容',
};

const orText: TipsMapType = {
  en: 'The content of the selected region/country, plus the content of the selected language',
  zh: '已选的【 region/country】的内容，再加上所有【已选语种】的内容',
};

function getTextItem(
  logic: string,
  type: string,
  text: string,
  value: string,
  tips: TipsMapType,
) {
  return (
    <BubbleCommon tipsMap={tips} showIcon={false} key={value} placement="right">
      <div
        className={`dbo-logic-select-item ${logic === value && 'is-active'}`}
      >
        <SvgIcon type={type} className="dbo-logic-select-icon" />
        <span>{text}</span>
      </div>
    </BubbleCommon>
  );
}

export const popularList: Array<string> = [
  'us',
  'jp',
  'kr',
  'th',
  'hk',
  'mo',
  'tw',
  'tr',
  'ru',
  'br',
  'mx',
];

export const logicTextMap: any = {
  and: {
    'en-US': 'and',
    'zh-CN': '且',
    type: 'init-join',
    tips: andText,
  },
  or: {
    'en-US': 'or',
    'zh-CN': '或',
    type: 'all-join',
    tips: orText,
  },
};

export const logicOptionsFn = (logic: string, lang: LangType) => {
  const resultElement: Array<{ text: JSX.Element; value: string }> = [];
  for (const key in logicTextMap) {
    if (Object.prototype.hasOwnProperty.call(logicTextMap, key)) {
      const item = logicTextMap[key as 'and' | 'or'];
      const { type, tips } = item;
      resultElement.push({
        value: key,
        text: getTextItem(logic, type, item[lang], key, tips),
      });
    }
  }
  return resultElement;
};

// 语言
export const lang_en = {
  aa: 'Afar',
  ab: 'Abkhazian',
  ae: 'Avestan',
  af: 'Afrikaans',
  ak: 'Akan',
  am: 'Amharic',
  an: 'Aragonese',
  ar: 'Arabic',
  as: 'Assamese',
  av: 'Avaric',
  ay: 'Aymara',
  az: 'Azerbaijani',
  ba: 'Bashkir',
  be: 'Belarusian',
  bg: 'Bulgarian',
  bh: 'Bihari',
  bi: 'Bislama',
  bm: 'Bambara',
  bn: 'Bengali',
  bo: 'Tibetan',
  br: 'Breton',
  bs: 'Bosnian',
  ca: 'Catalan',
  ce: 'Chechen',
  ch: 'Chamorro',
  co: 'Corsican',
  cr: 'Cree',
  cs: 'Czech',
  cu: 'Church Slavic',
  cv: 'Chuvash',
  cy: 'Welsh',
  da: 'Danish',
  de: 'German',
  dv: 'Divehi',
  dz: 'Dzongkha',
  ee: 'Ewe',
  el: 'Greek',
  en: 'English',
  eo: 'Esperanto',
  es: 'Spanish',
  et: 'Estonian',
  eu: 'Basque',
  fa: 'Persian',
  ff: 'Fulah',
  fi: 'Finnish',
  fj: 'Fijian',
  fo: 'Faroese',
  fr: 'French',
  fy: 'West Frisian',
  fil: 'Filipino',
  ga: 'Irish',
  gd: 'Gaelic',
  gl: 'Galician',
  gn: 'Guarani',
  gu: 'Gujarati',
  gv: 'Manx',
  ha: 'Hausa',
  he: 'Hebrew',
  hi: 'Hindi',
  ho: 'Hiri Motu',
  hr: 'Croatian',
  ht: 'Haitian',
  hu: 'Hungarian',
  hy: 'Armenian',
  hz: 'Herero',
  ia: 'Interlingua',
  id: 'Indonesian',
  ie: 'Interlingue',
  ig: 'Igbo',
  ii: 'Sichuan Yi, Nuosu',
  ik: 'Inupiaq',
  io: 'Ido',
  is: 'Icelandic',
  it: 'Italian',
  iu: 'Inuktitut',
  ja: 'Japanese',
  jv: 'Javanese',
  ka: 'Georgian',
  kg: 'Kongo',
  ki: 'Kikuyu',
  kj: 'Kuanyama',
  kk: 'Kazakh',
  kl: 'Kalaallisut',
  km: 'Central Khmer',
  kn: 'Kannada',
  ko: 'Korean',
  kr: 'Kanuri',
  ks: 'Kashmiri',
  ku: 'Kurdish',
  kv: 'Komi',
  kw: 'Cornish',
  ky: 'Kirghiz',
  la: 'Latin',
  lb: 'Luxembourgish',
  lg: 'Ganda',
  li: 'Limburgan',
  ln: 'Lingala',
  lo: 'Lao',
  lt: 'Lithuanian',
  lu: 'Luba-Katanga',
  lv: 'Latvian',
  mg: 'Malagasy',
  mh: 'Marshallese',
  mi: 'Maori',
  mk: 'Macedonian',
  ml: 'Malayalam',
  mn: 'Mongolian',
  mo: 'Moldavian',
  mr: 'Marathi',
  ms: 'Malay',
  mt: 'Maltese',
  my: 'Burmese',
  na: 'Nauru',
  nb: 'Norwegian Bokmål',
  nd: 'North Ndebele',
  ne: 'Nepali',
  ng: 'Ndonga',
  nl: 'Dutch',
  nn: 'Norwegian Nynorsk',
  no: 'Norwegian',
  nr: 'South Ndebele',
  nv: 'Navajo',
  ny: 'Chichewa',
  oc: 'Occitan',
  oj: 'Ojibwa',
  om: 'Oromo',
  or: 'Oriya',
  os: 'Ossetian',
  pa: 'Punjabi',
  pi: 'Pali',
  pl: 'Polish',
  ps: 'Pashto',
  pt: 'Portuguese',
  qu: 'Quechua',
  rm: 'Romansh',
  rn: 'Rundi',
  ro: 'Romanian',
  ru: 'Russian',
  rw: 'Kinyarwanda',
  sa: 'Sanskrit',
  sc: 'Sardinian',
  sd: 'Sindhi',
  se: 'Northern Sami',
  sg: 'Sango',
  sh: 'Serbo-Croatian',
  si: 'Sinhala',
  sk: 'Slovak',
  sl: 'Slovenian',
  sm: 'Samoan',
  sn: 'Shona',
  so: 'Somali',
  sq: 'Albanian',
  sr: 'Serbian',
  ss: 'Swati',
  st: 'Southern Sotho',
  su: 'Sundanese',
  sv: 'Swedish',
  sw: 'Swahili',
  ta: 'Tamil',
  te: 'Telugu',
  tg: 'Tajik',
  th: 'Thai',
  ti: 'Tigrinya',
  tk: 'Turkmen',
  tl: 'Tagalog',
  tn: 'Tswana',
  to: 'Tonga',
  tr: 'Turkish',
  ts: 'Tsonga',
  tt: 'Tatar',
  tw: 'Twi',
  ty: 'Tahitian',
  ug: 'Uighur',
  uk: 'Ukrainian',
  ur: 'Urdu',
  uz: 'Uzbek',
  ve: 'Venda',
  vi: 'Vietnamese',
  vo: 'Volapük',
  wa: 'Walloon',
  wo: 'Wolof',
  xh: 'Xhosa',
  yi: 'Yiddish',
  yo: 'Yoruba',
  za: 'Zhuang',
  zh: 'Simplified Chinese',
  'zh-tw': 'Traditional Chinese',
  zu: 'Zulu',
};
// 国家
export const region_en = {
  ad: 'Andorra',
  ae: 'UAE',
  af: 'Afghanistan',
  ag: 'Antigua and Barbuda',
  al: 'Albania',
  am: 'Armenia',
  ao: 'Angola',
  ar: 'Argentina',
  at: 'Austria',
  au: 'Australia',
  az: 'Azerbaijan',
  ba: 'Bosnia and Herzegovina',
  bb: 'Barbados',
  bd: 'Bangladesh',
  be: 'Belgium',
  bf: 'Burkina Faso',
  bg: 'Bulgaria',
  bh: 'Bahrain',
  bi: 'Burundi',
  bj: 'Benin',
  bn: 'Brunei Darussalam',
  bo: 'Bolivia',
  br: 'Brazil',
  bs: 'Bahamas',
  bt: 'Bhutan',
  bw: 'Botswana',
  by: 'Belarus',
  bz: 'Belize',
  ca: 'Canada',
  cf: 'Central African Republic',
  cg: 'Congo',
  ch: 'Switzerland',
  ci: "Côte d'Ivoire",
  ck: 'Cook Islands',
  cl: 'Chile',
  cm: 'Cameroon',
  cn: 'China',
  co: 'Colombia',
  cr: 'Costa Rica',
  cu: 'Cuba',
  cv: 'Cabo Verde',
  cy: 'Cyprus',
  cz: 'Czechia',
  de: 'Germany',
  dj: 'Djibouti',
  dk: 'Denmark',
  dm: 'Dominica',
  do: 'Dominican Republic',
  dz: 'Algeria',
  ec: 'Ecuador',
  ee: 'Estonia',
  eg: 'Egypt',
  er: 'Eritrea',
  es: 'Spain',
  et: 'Ethiopia',
  fi: 'Finland',
  fj: 'Fiji',
  fm: 'Micronesia',
  fo: 'Faroe Islands',
  fr: 'France',
  ga: 'Gabon',
  gb: 'United Kingdom',
  gd: 'Grenada',
  ge: 'Georgia',
  gh: 'Ghana',
  gm: 'Gambia',
  gn: 'Guinea',
  gq: 'Equatorial Guinea',
  gr: 'Greece',
  gt: 'Guatemala',
  gw: 'Guinea-Bissau',
  gy: 'Guyana',
  hk: 'Hong Kong, China',
  hn: 'Honduras',
  hr: 'Croatia',
  ht: 'Haiti',
  hu: 'Hungary',
  id: 'Indonesia',
  ie: 'Ireland',
  il: 'Israel',
  in: 'India',
  iq: 'Iraq',
  ir: 'Iran',
  is: 'Iceland',
  it: 'Italy',
  jm: 'Jamaica',
  jo: 'Jordan',
  jp: 'Japan',
  ke: 'Kenya',
  kg: 'Kyrgyzstan',
  kh: 'Cambodia',
  ki: 'Kiribati',
  km: 'Comoros',
  kn: 'Saint Kitts and Nevis',
  kp: 'North Korea',
  kr: 'South Korea',
  kw: 'Kuwait',
  kz: 'Kazakhstan',
  la: "Lao People's Democratic Republic",
  lb: 'Lebanon',
  lc: 'Saint Lucia',
  lk: 'Sri Lanka',
  lr: 'Liberia',
  ls: 'Lesotho',
  lt: 'Lithuania',
  lu: 'Luxembourg',
  lv: 'Latvia',
  ly: 'Libya',
  ma: 'Morocco',
  mc: 'Monaco',
  md: 'Republic of Moldova',
  me: 'Montenegro',
  mg: 'Madagascar',
  mh: 'Marshall Islands',
  mk: 'North Macedonia',
  ml: 'Mali',
  mm: 'Myanmar',
  mn: 'Mongolia',
  mo: 'Macau, China',
  mr: 'Mauritania',
  mt: 'Malta',
  mu: 'Mauritius',
  mv: 'Maldives',
  mw: 'Malawi',
  mx: 'Mexico',
  my: 'Malaysia',
  mz: 'Mozambique',
  na: 'Namibia',
  ne: 'Niger',
  ng: 'Nigeria',
  ni: 'Nicaragua',
  nl: 'Netherlands',
  no: 'Norway',
  np: 'Nepal',
  nr: 'Nauru',
  nu: 'Niue',
  nz: 'New Zealand',
  om: 'Oman',
  pa: 'Panama',
  pe: 'Peru',
  pg: 'Papua New Guinea',
  ph: 'Philippines',
  pk: 'Pakistan',
  pl: 'Poland',
  pt: 'Portugal',
  pw: 'Palau',
  py: 'Paraguay',
  qa: 'Qatar',
  ro: 'Romania',
  rs: 'Serbia',
  ru: 'Russian',
  rw: 'Rwanda',
  sa: 'Saudi Arabia',
  sb: 'Solomon Islands',
  sc: 'Seychelles',
  sd: 'Sudan',
  se: 'Sweden',
  sg: 'Singapore',
  si: 'Slovenia',
  sk: 'Slovakia',
  sl: 'Sierra Leone',
  sm: 'San Marino',
  sn: 'Senegal',
  so: 'Somalia',
  sr: 'Suriname',
  ss: 'South Sudan',
  st: 'Sao Tome and Principe',
  sv: 'El Salvador',
  sy: 'Syrian Arab Republic',
  sz: 'Eswatini',
  td: 'Chad',
  tg: 'Togo',
  th: 'Thailand',
  tj: 'Tajikistan',
  tk: 'Tokelau',
  tl: 'Timor-Leste',
  tm: 'Turkmenistan',
  tn: 'Tunisia',
  to: 'Tonga',
  tr: 'Turkey',
  tt: 'Trinidad and Tobago',
  tv: 'Tuvalu',
  tw: 'Taiwan, China',
  tz: 'United Republic of Tanzania',
  ua: 'Ukraine',
  ug: 'Uganda',
  us: 'United States',
  uy: 'Uruguay',
  uz: 'Uzbekistan',
  vc: 'Saint Vincent and the Grenadines',
  ve: 'Venezuela',
  vn: 'Vietnam',
  vu: 'Vanuatu',
  ws: 'Samoa',
  ye: 'Yemen',
  za: 'South Africa',
  zm: 'Zambia',
  zw: 'Zimbabwe',
};
// 国家(中文)
export const region_cn = {
  ad: '安道尔',
  ae: '阿联酋',
  af: '阿富汗',
  ag: '安提瓜和巴布达',
  al: '阿尔巴尼亚',
  am: '亚美尼亚',
  ao: '安哥拉',
  ar: '阿根廷',
  at: '奥地利',
  au: '澳大利亚',
  az: '阿塞拜疆',
  ba: '波斯尼亚和黑塞哥维那',
  bb: '巴巴多斯',
  bd: '孟加拉国',
  be: '比利时',
  bf: '布基纳法索',
  bg: '保加利亚',
  bh: '巴林',
  bi: '布隆迪',
  bj: '贝宁',
  bn: '文莱',
  bo: '玻利维亚',
  br: '巴西',
  bs: '巴哈马',
  bt: '不丹',
  bw: '博茨瓦纳',
  by: '白俄罗斯',
  bz: '伯利兹',
  ca: '加拿大',
  cf: '中非共和国',
  cg: '刚果',
  ch: '瑞士',
  ci: '科特迪瓦',
  ck: '库克群岛',
  cl: '智利',
  cm: '喀麦隆',
  cn: '中国',
  co: '哥伦比亚',
  cr: '哥斯达黎加',
  cu: '古巴',
  cv: '佛得角',
  cy: '塞浦路斯',
  cz: '捷克',
  de: '德国',
  dj: '吉布提',
  dk: '丹麦',
  dm: '多米尼克',
  do: '多米尼加',
  dz: '阿尔及利亚',
  ec: '厄瓜多尔',
  ee: '爱沙尼亚',
  eg: '埃及',
  er: '厄立特里亚',
  es: '西班牙',
  et: '埃塞俄比亚',
  fi: '芬兰',
  fj: '斐济',
  fm: '密克罗尼西亚',
  fo: '法罗群岛',
  fr: '法国',
  ga: '加蓬',
  gb: '英国',
  gd: '格林纳达',
  ge: '格鲁吉亚',
  gh: '加纳',
  gm: '冈比亚',
  gn: '几内亚',
  gq: '赤道几内亚',
  gr: '希腊',
  gt: '危地马拉',
  gw: '几内亚比绍',
  gy: '圭亚那',
  hk: '中国香港',
  hn: '洪都拉斯',
  hr: '克罗地亚',
  ht: '海地',
  hu: '匈牙利',
  id: '印尼',
  ie: '爱尔兰',
  il: '以色列',
  in: '印度',
  iq: '伊拉克',
  ir: '伊朗',
  is: '冰岛',
  it: '意大利',
  jm: '牙买加',
  jo: '约旦',
  jp: '日本',
  ke: '肯尼亚',
  kg: '吉尔吉斯斯坦',
  kh: '柬埔寨',
  ki: '基里巴斯',
  km: '科摩罗',
  kn: '圣基茨和尼维斯',
  kp: '朝鲜',
  kr: '韩国',
  kw: '科威特',
  kz: '哈萨克斯坦',
  la: '老挝',
  lb: '黎巴嫩',
  lc: '圣卢西亚',
  lk: '斯里兰卡',
  lr: '利比里亚',
  ls: '莱索托',
  lt: '立陶宛',
  lu: '卢森堡',
  lv: '拉脱维亚',
  ly: '利比亚',
  ma: '摩洛哥',
  mc: '摩纳哥',
  md: '摩尔多瓦共和国',
  me: '黑山',
  mg: '马达加斯加',
  mh: '马绍尔群岛',
  mk: '北马其顿',
  ml: '马里',
  mm: '缅甸',
  mn: '蒙古',
  mo: '中国澳门',
  mr: '毛里塔尼亚',
  mt: '马耳他',
  mu: '毛里求斯',
  mv: '马尔代夫',
  mw: '马拉维',
  mx: '墨西哥',
  my: '马来西亚',
  mz: '莫桑比克',
  na: '纳米比亚',
  ne: '尼日尔',
  ng: '尼日利亚',
  ni: '尼加拉瓜',
  nl: '荷兰',
  no: '挪威',
  np: '尼泊尔',
  nr: '瑙鲁',
  nu: '纽埃',
  nz: '新西兰',
  om: '阿曼',
  pa: '巴拿马',
  pe: '秘鲁',
  pg: '巴布亚新几内亚',
  ph: '菲律宾',
  pk: '巴基斯坦',
  pl: '波兰',
  pt: '葡萄牙',
  pw: '帕劳',
  py: '巴拉圭',
  qa: '卡塔尔',
  ro: '罗马尼亚',
  rs: '塞尔维亚',
  ru: '俄罗斯',
  rw: '卢旺达',
  sa: '沙特阿拉伯',
  sb: '所罗门群岛',
  sc: '塞舌尔',
  sd: '苏丹',
  se: '瑞典',
  sg: '新加坡',
  si: '斯洛文尼亚',
  sk: '斯洛伐克',
  sl: '塞拉利昂',
  sm: '圣马力诺',
  sn: '塞内加尔',
  so: '索马里',
  sr: '苏里南',
  ss: '南苏丹',
  st: '圣多美和普林西比',
  sv: '萨尔瓦多',
  sy: '叙利亚',
  sz: '斯威士兰',
  td: '乍得',
  tg: '多哥',
  th: '泰国',
  tj: '塔吉克斯坦',
  tk: '托克劳',
  tl: '东帝汶',
  tm: '土库曼斯坦',
  tn: '突尼斯',
  to: '汤加',
  tr: '土耳其',
  tt: '特立尼达和多巴哥',
  tv: '图瓦卢',
  tw: '中国台湾',
  tz: '坦桑尼亚',
  ua: '乌克兰',
  ug: '乌干达',
  us: '美国',
  uy: '乌拉圭',
  uz: '乌兹别克斯坦',
  vc: '圣文森特和格林纳丁斯',
  ve: '委内瑞拉',
  vn: '越南',
  vu: '瓦努阿图',
  ws: '萨摩亚',
  ye: '也门',
  za: '南非',
  zm: '赞比亚',
  zw: '津巴布韦',
};

// 地区
export const region1_en = {
  AF: 'Africa',
  CHN: 'China(Mainland)',
  EUR: 'Europe',
  Global: 'Global',
  IN: 'India',
  JPN: 'Japan',
  KR: 'South Korea',
  ME: 'Middle East',
  NA: 'North America',
  OA: 'Oceania',
  'Other Asia': 'Other Asia',
  SA: 'South America',
  SEA: 'Southeast Asia',
  HMT: 'HKG/OMA/TW',
  GLOBAL: 'Global',
  WE: 'West Europe',
  EE: 'East Europe',
};

const tipsInfoMap = {
  zh: '“全球”包括来自游戏商店和社交媒体，并且无法区分地区/市场的评论。',
  en: 'Global refers to the reviews from game store and social media, which cannot be distinguished from regions/countries.',
};

const influencerTipsInfoMap = {
  zh: '全球数据包括没有定义国家/地区的Influencer。',
  en: 'Global data includes Influencer with no country/region defined.',
};

const regionIconTipsMap = {
  common: tipsInfoMap,
  influencer: influencerTipsInfoMap,
  urlCommon: null
};

export const regionRadioOptions = (type: TipsType) => {
  return [
    {
      value: 'global',
      text: 'Global',
      textCN: '全球',
      infoIcon: <BubbleCommon tipsMap={regionIconTipsMap[type]}></BubbleCommon>,
    },
    {
      value: 'global_wo_china',
      text: 'Global except China mainland',
      textCN: '全球（不包括中国大陆）',
    },
  ];
};

export const regionTitleLocal = {
  en: {
    common: 'Common',
    popular: 'Key Country/Market',
    radio_title: 'Overall',
    region_title: 'Region',
    market_title: 'Country/Market',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: 'Region',
    button_market: 'Country/Market',
    search_none: 'No result found',
    country_no_data: 'No result found',
    aggregated_data_under_global: `Global: Shows the total value in global countries. It is shown directly and independently, but not the aggregate value of all available countries below.  For MScience data, it's the accumulate or weighted average data of 5 countries. For engagement data, it's the weighted average data of 37 countries.`,
    aggregated_data_under_global_except: `Global except China mainland: Shows the total value in global countries except China mainland. We use global data minus data of China mainland. For MScience data, it's the accumulate or weighted average data of 5 countries. For engagement data, there's no data of China and it's the weighted average data of 37 countries.`,
    global_global_wo_china_tips_of_top_companies:
      'Here display the aggregated value of all available countries below. 70 countries for mobile game data and US/UK/FR/DE/ES for PC & Console game data.',
  },
  cn: {
    common: '全部',
    popular: '重点关注国家/市场',
    radio_title: '聚合数据',
    region_title: '区域',
    market_title: '国家/市场',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: '区域',
    button_market: '国家/市场',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
    aggregated_data_under_global:
      '全球：展示全球整体数据。直接通过统计模型所得，不是所有国家的加总。对于MScience数据是5个国家的加总/加权平均值。对于活跃数据，是37个国家的月活加权平均值。',
    aggregated_data_under_global_except:
      '海外：展示全球除了中国大陆之外的数据。通过全球数据减去中国大陆所得。对于MScience数据是5个国家的加总/加权平均值。对于活跃数据，因为没有中国数据，所以海外数据和全球数据相同，是37个国家的月活加权平均值。',
    global_global_wo_china_tips_of_top_companies:
      '这里显示下面所有可用国家/地区的合计值。 提供70 个国家/地区的手机游戏数据以及美英法德西的 PC 和主机游戏数据。',
  },
};

export const accountRegionTitleLocal = {
  en: {
    common: 'Common',
    popular: 'Key Country/Market',
    radio_title: 'Overall',
    region_title: 'Account Region',
    market_title: 'Country/Market',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: 'Account Region',
    button_market: 'Country/Market',
    search_none: 'No result found',
    country_no_data: 'No result found',
    aggregated_data_under_global: `Global: Shows the total value in global countries. It is shown directly and independently, but not the aggregate value of all available countries below.  For MScience data, it's the accumulate or weighted average data of 5 countries. For engagement data, it's the weighted average data of 37 countries.`,
    aggregated_data_under_global_except: `Global except China mainland: Shows the total value in global countries except China mainland. We use global data minus data of China mainland. For MScience data, it's the accumulate or weighted average data of 5 countries. For engagement data, there's no data of China and it's the weighted average data of 37 countries.`,
    global_global_wo_china_tips_of_top_companies:
      'Here display the aggregated value of all available countries below. 70 countries for mobile game data and US/UK/FR/DE/ES for PC & Console game data.',
  },
  cn: {
    common: '全部',
    popular: '重点关注国家/市场',
    radio_title: '聚合数据',
    region_title: '账号区域',
    market_title: '国家/市场',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: '账号区域',
    button_market: '国家/市场',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
    aggregated_data_under_global:
      '全球：展示全球整体数据。直接通过统计模型所得，不是所有国家的加总。对于MScience数据是5个国家的加总/加权平均值。对于活跃数据，是37个国家的月活加权平均值。',
    aggregated_data_under_global_except:
      '海外：展示全球除了中国大陆之外的数据。通过全球数据减去中国大陆所得。对于MScience数据是5个国家的加总/加权平均值。对于活跃数据，因为没有中国数据，所以海外数据和全球数据相同，是37个国家的月活加权平均值。',
    global_global_wo_china_tips_of_top_companies:
      '这里显示下面所有可用国家/地区的合计值。 提供70 个国家/地区的手机游戏数据以及美英法德西的 PC 和主机游戏数据。',
  },
};

export const languageTitleLocal = {
  en: {
    market_title: 'Language',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: 'Language',
    button_market: 'Language',
    search_none: 'No result found',
    country_no_data: 'No result found',
  },
  cn: {
    market_title: '语种',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: '语种',
    button_market: '语种',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
  },
};

export const languageRadioOptions = [
  {
    value: 'global',
    text: 'All',
    textCN: '全部',
  },
];

export const kolRegionTitleLocal = {
  en: {
    common: 'Common',
    popular: 'Key Country/Market',
    radio_title: 'Overall',
    region_title: 'KOL Region',
    market_title: 'KOL Country/Market',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: 'KOL Region',
    button_market: 'KOL Country/Market',
    search_none: 'No result found',
    country_no_data: 'No result found',
    aggregated_data_under_global: `Global: Shows the total value in global countries. It is shown directly and independently, but not the aggregate value of all available countries below.  For MScience data, it's the accumulate or weighted average data of 5 countries. For engagement data, it's the weighted average data of 37 countries.`,
    aggregated_data_under_global_except: `Global except China mainland: Shows the total value in global countries except China mainland. We use global data minus data of China mainland. For MScience data, it's the accumulate or weighted average data of 5 countries. For engagement data, there's no data of China and it's the weighted average data of 37 countries.`,
    global_global_wo_china_tips_of_top_companies:
      'Here display the aggregated value of all available countries below. 70 countries for mobile game data and US/UK/FR/DE/ES for PC & Console game data.',
  },
  cn: {
    common: '全部',
    popular: '重点关注国家/市场',
    radio_title: '聚合数据',
    region_title: 'KOL区域',
    market_title: 'KOL国家/市场',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: 'KOL区域',
    button_market: 'KOL国家/市场',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
    aggregated_data_under_global:
      '全球：展示全球整体数据。直接通过统计模型所得，不是所有国家的加总。对于MScience数据是5个国家的加总/加权平均值。对于活跃数据，是37个国家的月活加权平均值。',
    aggregated_data_under_global_except:
      '海外：展示全球除了中国大陆之外的数据。通过全球数据减去中国大陆所得。对于MScience数据是5个国家的加总/加权平均值。对于活跃数据，因为没有中国数据，所以海外数据和全球数据相同，是37个国家的月活加权平均值。',
    global_global_wo_china_tips_of_top_companies:
      '这里显示下面所有可用国家/地区的合计值。 提供70 个国家/地区的手机游戏数据以及美英法德西的 PC 和主机游戏数据。',
  },
};
